import { z } from 'zod';

export type AccountEventType =
  | 'AccountSetupBannerViewed'
  | 'AccountSetupBannerDismissed'
  | 'AccountActionBlocked'
  | 'EmailValidationResendClicked'
  | 'AccountCompletenessPopupCompleted';

// Account event payload schemas
export const AccountSetupBannerViewedPayloadSchema = z.object({
  missingAddress: z.boolean(),
  missingEmailVerification: z.boolean(),
});

export const AccountSetupBannerDismissedPayloadSchema = z.object({
  missingAddress: z.boolean(),
  missingEmailVerification: z.boolean(),
});

export const AccountActionBlockedPayloadSchema = z.object({
  page: z.string(),
  view: z.enum(['affiliate', 'vendor']),
  action: z.enum(['approval_request', 'promote_product', 'grant_access', 'create_api_key']),
  missingSteps: z.array(z.string()),
});

export const EmailValidationResendClickedPayloadSchema = z.object({
  page: z.string(),
  view: z.enum(['affiliate', 'vendor']),
  source: z.enum(['banner', 'action_popup']),
});

export const AccountCompletenessPopupCompletedPayloadSchema = z.object({
  source: z.string(),
});

export type AccountEventTypePayloadMap = {
  AccountSetupBannerViewed: z.infer<typeof AccountSetupBannerViewedPayloadSchema>;
  AccountSetupBannerDismissed: z.infer<typeof AccountSetupBannerDismissedPayloadSchema>;
  AccountActionBlocked: z.infer<typeof AccountActionBlockedPayloadSchema>;
  EmailValidationResendClicked: z.infer<typeof EmailValidationResendClickedPayloadSchema>;
  AccountCompletenessPopupCompleted: z.infer<typeof AccountCompletenessPopupCompletedPayloadSchema>;
};

export const AccountEventSchemaMap = {
  AccountSetupBannerViewed: AccountSetupBannerViewedPayloadSchema,
  AccountSetupBannerDismissed: AccountSetupBannerDismissedPayloadSchema,
  AccountActionBlocked: AccountActionBlockedPayloadSchema,
  EmailValidationResendClicked: EmailValidationResendClickedPayloadSchema,
  AccountCompletenessPopupCompleted: AccountCompletenessPopupCompletedPayloadSchema,
};
